import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { UserState } from '../../states';
import { waitForUserLoaded } from './wait-for-user-loaded.util';

/**
 * Route guard that grants access only to users with the admin role.
 * Awaits initial user loading (see `canActivateUser`) before checking the
 * `UserState.isAdmin` selector, then redirects non-admins to the app root.
 */
export const canActivateAdmin: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const store = inject(Store);
    const router = inject(Router);

    await waitForUserLoaded(store);

    return store.selectSnapshot(UserState.isAdmin) ? true : router.parseUrl('/');
};
